export const formatDateForInput = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;
  const partsDdMmYyyy = dateString.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (partsDdMmYyyy) {
    return `${partsDdMmYyyy[3]}-${partsDdMmYyyy[2].padStart(
      2,
      "0"
    )}-${partsDdMmYyyy[1].padStart(2, "0")}`;
  }
  try {
    const dateObj = new Date(dateString);
    if (!isNaN(dateObj.getTime())) return dateObj.toISOString().split("T")[0];
  } catch (e) {
    /* Ignore */
  }
  return "";
};

export const formatDate = (timestampInput) => {
  if (!timestampInput) return "N/A";
  let date;
  if (timestampInput.toDate) {
    date = timestampInput.toDate();
  } else if (
    typeof timestampInput === "string" ||
    typeof timestampInput === "number"
  ) {
    date = new Date(timestampInput);
  } else if (timestampInput instanceof Date) {
    date = timestampInput;
  } else {
    return "Invalid Date Object";
  }
  return isNaN(date.getTime())
    ? "Invalid Date"
    : date.toLocaleDateString() + " " + date.toLocaleTimeString();
};